import {get_alert_list} from '../../alerts';
import { AlertFilterMap } from '../../Alerts/alertFilterMap';

import {FETCH_ALERT_LIST_BEGIN, FETCH_ALERT_LIST_SUCCESS, FETCH_ALERT_LIST_FAILURE, INVALIDATE_ALERT_LIST} from './actionTypes.js';

export function fetchAlertListBegin() {
    return { type: FETCH_ALERT_LIST_BEGIN };
}


export function fetchAlertListSuccess(alerts) {
    return {
        type: FETCH_ALERT_LIST_SUCCESS,
        payload: alerts,
        time_fetched: new Date(Date.now()),
    }
}

export function fetchAlertListFaliure(err) {
    return { type:FETCH_ALERT_LIST_FAILURE, payload: err, time_fetched: new Date(0)}
}

export function invalidateAlertsList() {
    return { type: INVALIDATE_ALERT_LIST, time_fetched: new Date(0) }; 
}

export function retrieveAlertsPage(offset = 0, far_significance_threshold, retracted, filterMap = new AlertFilterMap()) {

    return dispatch => {
        dispatch(fetchAlertListBegin());
        get_alert_list(offset, far_significance_threshold, retracted, filterMap)
        .then(response => {
            dispatch(fetchAlertListSuccess(response));
        })
        .catch(err => { 
            dispatch(fetchAlertListFaliure(err));
        })
    }
}